/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { PieceJointeRapportIncidentDto } from '../models/piece-jointe-rapport-incident-dto';
import { RapportIncidentDto } from '../models/rapport-incident-dto';
import { TypePieceJointeValues } from '../models/type-piece-jointe-values';


/**
 * Fonctions de gestion des rapports d'incident
 */
@Injectable({
  providedIn: 'root',
})
export class RapportIncidentService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation rapportIncidentGetList
   */
  static readonly RapportIncidentGetListPath = '/api/rapport-incident/list';

  /**
   * Renvoie la liste des rapports.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<RapportIncidentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<RapportIncidentDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des rapports.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGetList(params?: {
  }): Observable<Array<RapportIncidentDto>> {

    return this.rapportIncidentGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<RapportIncidentDto>>) => r.body as Array<RapportIncidentDto>)
    );
  }

  /**
   * Path part for operation rapportIncidentLoadList
   */
  static readonly RapportIncidentLoadListPath = '/api/rapport-incident/load-list';

  /**
   * Renvoie la liste des rapports d'incident (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des rapports d'incident (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.rapportIncidentLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation rapportIncidentGet
   */
  static readonly RapportIncidentGetPath = '/api/rapport-incident/{id}';

  /**
   * Renvoie le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGet$Response(params: {

    /**
     * Identifiant du rapport d&#x27;incident
     */
    id: number;
  }): Observable<StrictHttpResponse<RapportIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportIncidentDto>;
      })
    );
  }

  /**
   * Renvoie le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGet(params: {

    /**
     * Identifiant du rapport d&#x27;incident
     */
    id: number;
  }): Observable<RapportIncidentDto> {

    return this.rapportIncidentGet$Response(params).pipe(
      map((r: StrictHttpResponse<RapportIncidentDto>) => r.body as RapportIncidentDto)
    );
  }

  /**
   * Path part for operation rapportIncidentPut
   */
  static readonly RapportIncidentPutPath = '/api/rapport-incident/{id}';

  /**
   * Met à jour le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentPut$Response(params: {

    /**
     * Identifiant du rapport d&#x27;incident à mettre à jour
     */
    id: number;

    /**
     * Rapport d'incident
     */
    body: RapportIncidentDto
  }): Observable<StrictHttpResponse<RapportIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportIncidentDto>;
      })
    );
  }

  /**
   * Met à jour le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentPut(params: {

    /**
     * Identifiant du rapport d&#x27;incident à mettre à jour
     */
    id: number;

    /**
     * Rapport d'incident
     */
    body: RapportIncidentDto
  }): Observable<RapportIncidentDto> {

    return this.rapportIncidentPut$Response(params).pipe(
      map((r: StrictHttpResponse<RapportIncidentDto>) => r.body as RapportIncidentDto)
    );
  }

  /**
   * Path part for operation rapportIncidentDelete
   */
  static readonly RapportIncidentDeletePath = '/api/rapport-incident/{id}';

  /**
   * Supprime le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentDelete$Response(params: {

    /**
     * Identifiant du rapport d&#x27;incident à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentDelete(params: {

    /**
     * Identifiant du rapport d&#x27;incident à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.rapportIncidentDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation rapportIncidentGetFiles
   */
  static readonly RapportIncidentGetFilesPath = '/api/rapport-incident/{id}/files';

  /**
   * Récupère la liste des fichiers liés au rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentGetFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGetFiles$Response(params: {

    /**
     * Identifiant du rapport
     */
    id: number;
  }): Observable<StrictHttpResponse<Array<PieceJointeRapportIncidentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentGetFilesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PieceJointeRapportIncidentDto>>;
      })
    );
  }

  /**
   * Récupère la liste des fichiers liés au rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentGetFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGetFiles(params: {

    /**
     * Identifiant du rapport
     */
    id: number;
  }): Observable<Array<PieceJointeRapportIncidentDto>> {

    return this.rapportIncidentGetFiles$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PieceJointeRapportIncidentDto>>) => r.body as Array<PieceJointeRapportIncidentDto>)
    );
  }

  /**
   * Path part for operation rapportIncidentAddRapportIncidentFichier
   */
  static readonly RapportIncidentAddRapportIncidentFichierPath = '/api/rapport-incident/{id}/file';

  /**
   * Ajoute un fichier au rapport spécifiée
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentAddRapportIncidentFichier()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentAddRapportIncidentFichier$Response(params: {

    /**
     * Identifiant du rapport d&#x27;incident
     */
    id: number;

    /**
     * Type de pièce jointe
     */
    type?: TypePieceJointeValues;

    /**
     * Nom du fichier envoyé
     */
    filename?: string;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentAddRapportIncidentFichierPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('type', params.type, {});
      rb.query('filename', params.filename, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Ajoute un fichier au rapport spécifiée
   * Taille maximum pour la photo : 20Mb.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentAddRapportIncidentFichier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentAddRapportIncidentFichier(params: {

    /**
     * Identifiant du rapport d&#x27;incident
     */
    id: number;

    /**
     * Type de pièce jointe
     */
    type?: TypePieceJointeValues;

    /**
     * Nom du fichier envoyé
     */
    filename?: string;
  }): Observable<number> {

    return this.rapportIncidentAddRapportIncidentFichier$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation rapportIncidentUpdateFileConfidentiality
   */
  static readonly RapportIncidentUpdateFileConfidentialityPath = '/api/rapport-incident/{id}/confidentiality';

  /**
   * Mets à jour le statut de confidentialité d'un fichier.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentUpdateFileConfidentiality()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentUpdateFileConfidentiality$Response(params: {

    /**
     * Identifiant du rapport d&#x27;incident
     */
    id: number;

    /**
     * True si confidentiel, false sinon
     */
    isConfidential?: boolean;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentUpdateFileConfidentialityPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('isConfidential', params.isConfidential, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Mets à jour le statut de confidentialité d'un fichier.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentUpdateFileConfidentiality$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentUpdateFileConfidentiality(params: {

    /**
     * Identifiant du rapport d&#x27;incident
     */
    id: number;

    /**
     * True si confidentiel, false sinon
     */
    isConfidential?: boolean;
  }): Observable<boolean> {

    return this.rapportIncidentUpdateFileConfidentiality$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation rapportIncidentAddRapportIncidentPhotoPda
   */
  static readonly RapportIncidentAddRapportIncidentPhotoPdaPath = '/api/rapport-incident/{id}/file/pda';

  /**
   * Ajoute une ou plusieurs photo PDA au rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentAddRapportIncidentPhotoPda()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentAddRapportIncidentPhotoPda$Response(params: {

    /**
     * Identifiant du rapport d&quot;incident
     */
    id: number;

    /**
     * Type de pièce jointe
     */
    type?: TypePieceJointeValues;

    /**
     * Identifiants des photosPda
     */
    body: Array<number>
  }): Observable<StrictHttpResponse<RapportIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentAddRapportIncidentPhotoPdaPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('type', params.type, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportIncidentDto>;
      })
    );
  }

  /**
   * Ajoute une ou plusieurs photo PDA au rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentAddRapportIncidentPhotoPda$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentAddRapportIncidentPhotoPda(params: {

    /**
     * Identifiant du rapport d&quot;incident
     */
    id: number;

    /**
     * Type de pièce jointe
     */
    type?: TypePieceJointeValues;

    /**
     * Identifiants des photosPda
     */
    body: Array<number>
  }): Observable<RapportIncidentDto> {

    return this.rapportIncidentAddRapportIncidentPhotoPda$Response(params).pipe(
      map((r: StrictHttpResponse<RapportIncidentDto>) => r.body as RapportIncidentDto)
    );
  }

  /**
   * Path part for operation rapportIncidentGetFile
   */
  static readonly RapportIncidentGetFilePath = '/api/rapport-incident/files/{pieceJointeRapportIncidentId}';

  /**
   * Télécharge le fichier d'un rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentGetFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGetFile$Response(params: {

    /**
     * Identifiant du fichier du rapport d&#x27;incident
     */
    pieceJointeRapportIncidentId: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentGetFilePath, 'get');
    if (params) {
      rb.path('pieceJointeRapportIncidentId', params.pieceJointeRapportIncidentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Télécharge le fichier d'un rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentGetFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentGetFile(params: {

    /**
     * Identifiant du fichier du rapport d&#x27;incident
     */
    pieceJointeRapportIncidentId: number;
  }): Observable<void> {

    return this.rapportIncidentGetFile$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation rapportIncidentDeleteFichier
   */
  static readonly RapportIncidentDeleteFichierPath = '/api/rapport-incident/files/{pieceJointeRapportIncidentId}';

  /**
   * Supprime le fichier d'un rapport spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentDeleteFichier()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentDeleteFichier$Response(params: {

    /**
     * Identifiant du fichier d&#x27;un rapport d&#x27;incident
     */
    pieceJointeRapportIncidentId: number;
  }): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentDeleteFichierPath, 'delete');
    if (params) {
      rb.path('pieceJointeRapportIncidentId', params.pieceJointeRapportIncidentId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Supprime le fichier d'un rapport spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentDeleteFichier$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rapportIncidentDeleteFichier(params: {

    /**
     * Identifiant du fichier d&#x27;un rapport d&#x27;incident
     */
    pieceJointeRapportIncidentId: number;
  }): Observable<boolean> {

    return this.rapportIncidentDeleteFichier$Response(params).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation rapportIncidentPost
   */
  static readonly RapportIncidentPostPath = '/api/rapport-incident';

  /**
   * Crée le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rapportIncidentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentPost$Response(params: {

    /**
     * Rapport d'incident
     */
    body: RapportIncidentDto
  }): Observable<StrictHttpResponse<RapportIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, RapportIncidentService.RapportIncidentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RapportIncidentDto>;
      })
    );
  }

  /**
   * Crée le rapport d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rapportIncidentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  rapportIncidentPost(params: {

    /**
     * Rapport d'incident
     */
    body: RapportIncidentDto
  }): Observable<RapportIncidentDto> {

    return this.rapportIncidentPost$Response(params).pipe(
      map((r: StrictHttpResponse<RapportIncidentDto>) => r.body as RapportIncidentDto)
    );
  }

}
